import React from "react";
import WelcomeEquity from "./WelcomeEquity/WelcomeEquity";
import ProductWhyEquity from "./ProductWhyEquity/ProductWhyEquity";
import ProductTopEquity from "./ProductTopEquity/ProductTopEquity";
import ExploreEquities from "./ExploreEquities/ExploreEquities";
import FAQSection from "../Products/Faq/Faq";
import ProductEquityFAQ from "./ProductEquityFAQ/ProductEquityFAQ";
function ProductEquity() {
  return (
    <>
      <WelcomeEquity />
      <ProductWhyEquity /> 

          

          <ProductTopEquity /> 

      <ExploreEquities />
      <ProductEquityFAQ />
    </>
  );
}
export default ProductEquity;
